<!-- Loading State -->
@if (isLoading) {
  <div class="text-center py-8">
    <p class="text-slate-600">Lade Dateien...</p>
  </div>
}

<!-- Error State -->
@if (error) {
  <div class="bg-red-50 border border-red-200 rounded-lg p-4 text-red-700">
    {{ error }}
  </div>
}

<!-- File List -->
@if (!isLoading && !error && files.length > 0) {
  <div class="space-y-3">
    @for (file of files; track file.Id) {
      <div class="flex items-center gap-4 p-4 bg-white border border-slate-200 rounded-lg hover:shadow-md transition-shadow">

        <!-- File Icon -->
        <div class="flex-shrink-0 w-12 h-12 flex items-center justify-center">
          <img [src]="getFileIcon(file.FileName)"
               [alt]="file.FileName"
               class="w-12 h-12 object-contain">
        </div>

        <!-- File Info -->
        <div class="flex-1 min-w-0">
          <h3 class="font-semibold text-slate-800 truncate">
            {{ file.Title }}
          </h3>
          <p class="text-sm text-slate-600 mt-1">{{ file.Description }}</p>
          <p class="text-xs text-slate-400 mt-1">{{ file.FileName }}</p>
        </div>

        <!-- Action Buttons -->
        <div class="flex gap-2 flex-shrink-0">
          <!-- View Button -->
          <a [href]="downloadPath + file.FileName"
             target="_blank"
             class="px-4 py-2 bg-slate-600 text-white rounded-lg hover:bg-slate-700 transition-colors flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
            </svg>
            <span class="hidden sm:inline">Ansehen</span>
          </a>

          <!-- Download Button -->
          <a [href]="downloadPath + file.FileName"
             download
             class="px-4 py-2 bg-slate-100 text-slate-700 rounded-lg hover:bg-slate-200 transition-colors flex items-center gap-2">
            <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 10v6m0 0l-3-3m3 3l3-3m2 8H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"/>
            </svg>
            <span class="hidden sm:inline">Download</span>
          </a>
        </div>
      </div>
    }
  </div>
}

<!-- Empty State -->
@if (!isLoading && !error && files.length === 0) {
  <div class="text-center py-8 text-slate-500">
    <p>Keine Dateien verfügbar</p>
  </div>
}
